import { LoadingButton } from '@mui/lab';
import BasicModal from '../../common/BasicModal';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dispatch, FC, SetStateAction, useContext } from 'react';
import { CampaignContext } from '../../../contexts/CampaignContext';

type Props = {
	title: string;
	label: string;
	openModal: boolean;
	media: number;
	mediaType: string;
	setOpen: Dispatch<SetStateAction<boolean>>;
	setTitle: Dispatch<SetStateAction<string>>;
	setMediaType: Dispatch<SetStateAction<string>>;
	setMedia: Dispatch<SetStateAction<number>>;
	handleCreate: () => void;
};

const RecommendHourModal: FC<Props> = ({ openModal, mediaType, setMediaType, setOpen, title, label, media, handleCreate, setTitle, setMedia }) => {
	let { t } = useTranslation();
	let { fetchedMedias } = useContext(CampaignContext);
	const handleOpenModal = () => {
		setOpen(!openModal);
	};
	let filterMedia = fetchedMedias?.find(item => item.id === media);
	return (
		<BasicModal
			open={!!openModal}
			onClose={handleOpenModal}
			title={t(label)}
			titleClassName={'text-center grow '}
			subClassName={'flex flex-row-reverse'}
			className={'max-w-xl rounded-lg'}
			showBackIcon={false}
			action={
				<div className="w-full">
					<LoadingButton onClick={handleCreate} variant="contained" color="primary" className="mx-2">
						{t('register')}
					</LoadingButton>
					<Button onClick={handleOpenModal} variant="outlined" className="mx-2" color="error">
						{t('cancel')}
					</Button>
				</div>
			}
		>
			<Box className="mb-5 mt-6 flex flex-wrap justify-between gap-4">
				<TextField className="mb-2 w-2/5" placeholder={t('time_frame')} size="medium" value={title} onChange={e => setTitle(e.target.value)} />
				<FormControl className="w-2/5">
					<InputLabel>{t(label)}</InputLabel>
					<Select
						size="medium"
						id="media"
						value={media}
						onChange={e => {
							const value = e.target.value as number;
							setMedia(value);
						}}
					>
						{fetchedMedias?.map((item, index) => (
							<MenuItem key={index} value={item.id}>
								{item.title}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl className="w-2/5">
					<InputLabel>{t('media_type')}</InputLabel>
					<Select
						size="medium"
						id="media_type"
						value={mediaType}
						onChange={e => {
							const value = e.target.value;
							setMediaType(value);
						}}
					>
						{filterMedia && filterMedia?.types.length > 0 ? filterMedia?.types.map(item => <MenuItem value={item.id}>{item.name}</MenuItem>) : <MenuItem value={t('sms')}>{t('sms')}</MenuItem>}
					</Select>
				</FormControl>
			</Box>
		</BasicModal>
	);
};

export default RecommendHourModal;
